import React from 'react';
import styles from './index.less';
import failImg from '@tencent/docs-design-resources/image/desktop/png@3x/blankpage/blankpage_fileerror_160@3x.png';

interface IProps {
    tipMsg: string;
}

type IRef = React.ForwardedRef<HTMLDivElement>;

// 重新生成图片弹窗
export const ReplaceSlideContentFail = React.forwardRef(({ tipMsg }: IProps, ref: IRef) => (
    <div className={styles.container} style={{ top: 60 }} ref={ref}>
        <img src={failImg} width={160}></img>
        <div className={styles.text}>{tipMsg}</div>
    </div>
));

ReplaceSlideContentFail.displayName = 'replaceSlideContentFail';
